import styled, { css } from "styled-components";

const BadgeWrap = styled.div`
    display: flex;
    align-items: center;
`;

const PrefixText = styled.div`
 ${({theme}) => css(theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors.Foreground};
    &:after {
        content: " ";
        white-space: pre;
    }
`;

const ToolTipTriggerText = styled.div`
 ${({theme}) => css(theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors.Foreground};
    span {
        text-decoration: underline;
        cursor: help;
    }
`;

export { BadgeWrap, PrefixText, ToolTipTriggerText };
